export default __webpack_public_path__ + "static/media/leaderboard-ambient-glow.3a8ea35c.png";